const headTitleList: any[] = [
  {
    headTitle: "代行者ID",
  },
  {
    headTitle: "代行者名",
  },
  {
    headTitle: "",
  },
  {
    headTitle: "メールアドレス",
  },
  {
    headTitle: "",
  },
];

const contextText = `選択した代行者を削除します。<よろしいですか？`;
export { headTitleList, contextText };
